import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private headerPath: Array<string> = [];
  private headerPath$ = new Subject<any>();

  constructor() {}

  public getPath(): Observable<any> {
    return this.headerPath$.asObservable();
  }

  public addElementToPath(element: string) {
    this.headerPath.push(element);
    this.headerPath$.next(this.headerPath);
  }

  public deleteElementInPath() {
    this.headerPath.pop();
    this.headerPath$.next(this.headerPath);
  }

  public resetPath(firstElement) {
    this.headerPath = [];
    this.headerPath.push(firstElement);
    this.headerPath$.next(this.headerPath);
  }

  public deletePath() {
    this.headerPath = [];
  }
}
